// Tiny wrapper around Meta Pixel so we never crash if the script is blocked.
export const fbTrack = (event, params) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    try {
      if (params) window.fbq('track', event, params);
      else window.fbq('track', event);
    } catch (e) { /* noop */ }
  }
};
